import { Field } from '../../form/decorators/Field';
import EmbeddedForm from '../../form/EmbeddedForm';
import { TicketSales } from '../../types/api';
import { TicketTierForm } from './TicketTierForm';

export class TicketSalesForm extends EmbeddedForm<TicketSales> {
  @Field()
  public availableFrom?: Date;

  @Field()
  public availableUntil?: Date;

  @Field({ static: true })
  public tiers: TicketTierForm[] = [new TicketTierForm()];

  constructor(ticketSales?: TicketSales) {
    super(ticketSales);
    if (ticketSales) {
      this.availableFrom = new Date(ticketSales.availableFrom);
      this.availableUntil = ticketSales.availableUntil && new Date(ticketSales.availableUntil);
      this.tiers = ticketSales.tiers.map((tier) => new TicketTierForm(tier));
    } else {
      this.tiers[0].name = 'General admission';
    }
  }
}
